/**
 * cortex-admin の infra-graph API contract（zod schema + 型）。
 * API（apps/api/admin）と Web（apps/web/cortex-admin）が共有する。
 *
 * infra-graph は Pulumi state 由来のインフラトポロジ（BQ `cortex.infra_graph_*`）。
 * 俯瞰ビュー（stack 1 ノード + cross-stack 集約エッジ）と stack 詳細ビュー
 * （GCP 1 リソース = 1 ノード + stack 内エッジ）の 2 段で可視化する。
 *
 * @graph-stack cortex-admin
 * @graph-domain Infrastructure
 * @graph-business infra-graph 構成図の俯瞰 / stack 詳細 API ↔ Web 型を共有し、二重定義を排除する。
 * @graph-connects none
 */
import { z } from 'zod';
/** 俯瞰ビューの stack サマリ（1 stack = 1 ノード）。 @graph-connects none */
export const InfraGraphStackSummarySchema = z.object({
    id: z.string(),
    label: z.string(),
    count: z.number(),
    dominantKind: z.string(),
});
/** 俯瞰ビューの cross-stack 集約エッジ（stack ペア × edge 種別の件数）。 @graph-connects none */
export const InfraGraphStackEdgeSchema = z.object({
    source: z.string(),
    target: z.string(),
    type: z.string(),
    count: z.number(),
});
/** 俯瞰ビューの全体メタ情報。 @graph-connects none */
export const InfraGraphMetaSchema = z.object({
    stackCount: z.number(),
    resourceCount: z.number(),
    crossEdgeCount: z.number(),
});
/** 俯瞰ビューレスポンス。 @graph-connects none */
export const InfraGraphOverviewResponseSchema = z.object({
    stacks: z.array(InfraGraphStackSummarySchema),
    edges: z.array(InfraGraphStackEdgeSchema),
    meta: InfraGraphMetaSchema,
});
/** stack 詳細ビューの入力（stack 名）。 @graph-connects none */
export const InfraGraphStackInputSchema = z.object({
    stack: z.string().min(1),
});
/** stack 詳細ビューのリソースノード（GCP 1 リソース）。 @graph-connects none */
export const InfraGraphResourceNodeSchema = z.object({
    id: z.string(),
    name: z.string(),
    kind: z.string(),
});
/** stack 詳細ビューの stack 内エッジ（両端が同 stack のリソース）。 @graph-connects none */
export const InfraGraphResourceEdgeSchema = z.object({
    source: z.string(),
    target: z.string(),
    type: z.string(),
});
/** stack 詳細ビューレスポンス。 @graph-connects none */
export const InfraGraphStackDetailResponseSchema = z.object({
    stack: z.string(),
    nodes: z.array(InfraGraphResourceNodeSchema),
    edges: z.array(InfraGraphResourceEdgeSchema),
});
//# sourceMappingURL=infra-graph.js.map